export enum OutputsCommands {
  CloseOutputs = 'closeOutputs',
  OpenMomentOutputs = 'openMomentOutputs',
  OpenPermanentOutputs = 'openPermanentOutputs'
}